import React from 'react';
import Button from '@mui/material/Button';
import {FormattedMessage} from 'react-intl';

import useAppModalService from "../../../hooks/useAppModalService";
import LoginPopUp from "./LoginPopUp";

import './LoginButton.style.scss';

export default function LoginButton({onClose}) {
    const {openModal} = useAppModalService();

    const handleLoginClick = async () => {
        await openModal('login', 'info', {
            title: 'Login',
            modalComponent: LoginPopUp
        });
    }

    return (
        <Button variant="outlined" className={"LoginButton"} onClick={() => {
            handleLoginClick();
            onClose?.();
        }}>
            <FormattedMessage id={"navigationHeader.login"}/>
        </Button>
    );
}
